import script from "./NotificationBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationBadge.vue?vue&type=script&setup=true&lang=js"

import "./NotificationBadge.vue?vue&type=style&index=0&id=279ca0be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-279ca0be"]])

export default __exports__